export function ObjectArrayGroupByKey(array, key) {
    return array.reduce((groups, item) => ({
        ...groups,
        [item[key]]: [...(groups[item[key]] || []), item]
    }), {});
}
